import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';

export async function createReseller(form: any) {
    const response = await axiosWithAuthInterceptor.post(
        `${process.env.REACT_APP_LIMOOME_SERVER}/reseller`,
        form,
        {
            withCredentials: true
        }
    )

    return response.data;
}

export async function uploadImage(file: any) {
    const formData = new FormData();
    formData.append("image", file);

    // const response = await fetch(`${process.env.REACT_APP_LIMOOME_SERVER}/upload`, {
    //     method: "POST",
    //     body: formData,
    // });
    // const data = await response.json();
    // return data.imageUrl;
    return 'testURL'
}

export async function updateResellerWalletAmount(data: { adminId: number, walletAmount: number }) {
    const response = await axiosWithAuthInterceptor.post(
        `${process.env.REACT_APP_LIMOOME_SERVER}/reseller-wallet`,
        data,
        {
            withCredentials: true
        }
    )

    return response.data;
}
